import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef6ba0d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-purchase" }
const _hoisted_2 = { class: "form-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_5 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_6 = { class: "foot" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getShopPurchase, updateShopPurchase } from '@/apis/usercenter'
import { useGlobal } from '@/util/useLoading'
import useEdited from '@/util/useEdited'
import { purchaseCfg, purchaseUpt } from '@/apis/setup'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const api = useGlobal(purchaseCfg)
const apiAutoCreateOrderType = ref()
const purchaseInfo = ref({})
// const {
//   purchasePriceAdd,
//   payRepurchaseType
// } = await api().then((res) => res.data)
const getInfo = async () => {
  const config = await getShopPurchase().then(res => res.data)
  purchaseInfo.value = config
  model.apiAutoCreateOrderType = config.apiAutoCreateOrderType
  clear()
}
getInfo()
const [model, update, clear, reset] = useEdited({
  apiAutoCreateOrderType: ''
}, () => {
  purchaseUpt({
    ...purchaseInfo.value,
    ...model,
    updateChannel: 1
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      clear()
    }
  })
})
const handle = (index: any) => { model.apiAutoCreateOrderType = index }


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", {
          innerHTML: _unref(t)('当自动下单的商品不满足最小起订量，且有“一件购买”价时').split('\n').map(v => `<label>${v}</label>`).join('<br/>')
        }, null, 8, _hoisted_3)
      ]),
      _createVNode(_component_el_radio_group, {
        "model-value": _unref(model).apiAutoCreateOrderType
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_radio, {
              label: 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handle(1))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("每次询问")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_radio, {
              label: 2,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handle(2))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("不询问，自动下单成功（以“一件购买”价）")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(update)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}
}

})